import React, { useState, useEffect, useContext } from "react";
import { NextButton } from "../common/NextButton";
import { BackButton } from "../common/BackButton";
import { NavFooter } from "../common/NavFooter";
import { Transition } from "@headlessui/react";
import { isXamarin } from "../../services/mobileService";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import { DashboardHeader } from "../DashboardHeader";

export const SetupPageTemplate = ({
	children,
	onClickBack,
	onClickNext,
	headerDetails,
}) => {
	const heightClass = isXamarin() ? "h-screen" : "h-full";

	const { theme } = useContext(DiseaseGroupContext);
	const themePrimary = theme.primary();

	const [isPagingForward, setIsPagingForward] = useState(true);
	const [btimer, setBtimer] = useState();
	const [ntimer, setNtimer] = useState();
	const [transitionInProgress, setTransitionInProgress] = useState(false);

	const [isShowing, setIsShowing] = useState(false);
	useEffect(() => {
		setIsShowing(true);
	}, []);

	useEffect(() => {
		return () => {
			if (btimer) {
				clearTimeout(btimer);
				setBtimer();
			}

			if (ntimer) {
				clearTimeout(ntimer);
				setNtimer();
			}
		};
	}, [btimer, ntimer]);

	const handleOnBack = () => {
		if (transitionInProgress) {
			return;
		}

		setTransitionInProgress(true);
		setIsPagingForward(false);
		setIsShowing(false);
		const timer = setTimeout(() => {
			onClickBack();
			setIsShowing(true);
			setBtimer(0);
			setTransitionInProgress(false);
		}, 500);

		setBtimer(timer);
	};

	const handleOnNext = () => {
		if (transitionInProgress) {
			return;
		}

		setTransitionInProgress(true);
		setIsPagingForward(true);
		setIsShowing(false);
		const timer = setTimeout(() => {
			onClickNext();
			setIsShowing(true);
			setNtimer(0);
			setTransitionInProgress(false);
		}, 500);

		setNtimer(timer);
	};

	return (
		<div className={`fixed inset-0 white`}>
			<Transition
				className={`bg-white flex flex-col max-w-2xl mx-auto ${heightClass} relative`}
				show={isShowing}
				enter={`transform ease-in-out duration-500`}
				enterFrom={isPagingForward ? "translate-x-full" : "-translate-x-full"}
				enterTo={"translate-x-0"}
				leave={`transition-opacity ease-in-out duration-200`}
				leaveFrom={"opacity-100"}
				leaveTo={"opacity-0"}
			>
				<DashboardHeader
					title={headerDetails?.title}
					subtitle={
						headerDetails.currentPage !== undefined &&
						`Page ${headerDetails?.currentPage} of ${headerDetails?.pageCount}`
					}
				/>

				<div className={"flex-grow overflow-y-auto px-6 pt-2 sm:px-8 sm:pt-8"}>
					<div className={"mb-28 text-black max-w-panel mx-auto"}>
						{children}
					</div>
				</div>

				<div className={"absolute left-0 right-0 bottom-0"}>
					<NavFooter currentTheme={themePrimary} isBorderOff={true}>
						{onClickBack ? (
							<BackButton
								onClick={handleOnBack}
								variant={"navigationText"}
								showIcon={false}
							/>
						) : null}
						{onClickNext ? (
							<NextButton onClick={handleOnNext} variant={"navigationText"} />
						) : null}
					</NavFooter>
					<div
						className={
							"text-xs bg-white font-thin text-gray-600 w-full flex justify-center pb-4"
						}
					>
						&#169; 2021 Dash-Global Ltd.
					</div>
				</div>
			</Transition>
		</div>
	);
};
